import React from 'react'
import { 
  Modal,
  ModalBody,
  ModalHeader
} from 'reactstrap'

import SVGIcon from 'components/icon'

const InvalidEncodedContent = ({ open }) => {
  return (
    <Modal    
      centered={ true }
      scrollable={ true }
      contentClassName={ 'mh-100' }
      style={{ margin: 0, maxWidth: '100%', maxHeight: '100vh' }}
      isOpen={ open }>
      <ModalHeader>Alert</ModalHeader>
      <ModalBody style={{ height: '100vh', textAlign: "center" }}>
        <SVGIcon 
          className={ 'svg-icon mt-5' }
          style={{ fill: '#d01c28' }}
          svgHref={ "icon-exclamation" }/>
        <h4 className={ 'mt-5 text-center' }> 
          Please use a valid website link to access the content.
        </h4>
      </ModalBody>
    </Modal>
  )
}

export default InvalidEncodedContent;